/* Krugovi sa storijima — smenjivanje slika i pregled preko celog ekrana. */
(function () {
  var TRAJANJE = 5000
  var krugovi = document.getElementById('krugovi')
  var prica = document.getElementById('prica')
  if (!krugovi || !prica) return

  /* ---------- smenjivanje slika u krugovima ---------- */
  krugovi.querySelectorAll('li').forEach(function (li, red) {
    var kadrovi = li.querySelectorAll('.krugovi__kadar')
    var tacke = li.querySelectorAll('.krugovi__tacke i')
    if (kadrovi.length < 2) return
    var i = 0
    setInterval(function () {
      kadrovi[i].classList.remove('je-vidljiv')
      if (tacke[i]) tacke[i].classList.remove('je-aktivna')
      i = (i + 1) % kadrovi.length
      kadrovi[i].classList.add('je-vidljiv')
      if (tacke[i]) tacke[i].classList.add('je-aktivna')
    }, 2600 + red * 180)
  })

  /* ---------- pregled ---------- */
  var stavke = Array.prototype.slice.call(krugovi.querySelectorAll('li[data-kolekcija]'))
  var katIdx = 0, artikli = [], i = 0, tajmer = null, pauza = false
  var rezim = krugovi.getAttribute('data-rezim') || 'kolekcije'

  var el = {
    okvir: prica.querySelector('.prica__okvir'),
    trake: prica.querySelector('.prica__trake'),
    naziv: prica.querySelector('[data-uloga="naziv"]'),
    broj: prica.querySelector('[data-uloga="broj"]'),
    kat: prica.querySelector('.prica__kat'),
    slika: prica.querySelector('.prica__slika img'),
    ime: prica.querySelector('.prica__naziv'),
    cena: prica.querySelector('.prica__cena'),
    brojac: prica.querySelector('.prica__brojac'),
    detalji: prica.querySelector('.prica__detalji'),
    korpa: prica.querySelector('[data-uloga="korpa"] input[name="id"]'),
    odmah: prica.querySelector('[data-uloga="odmah"] input[name="id"]'),
    poruci: prica.querySelector('.prica__poruci')
  }

  function stani() { if (tajmer) { clearTimeout(tajmer); tajmer = null } }

  function zakaziSledeci() {
    stani()
    if (pauza || i >= artikli.length - 1) return
    tajmer = setTimeout(function () { idiNa(i + 1) }, TRAJANJE)
  }

  function crtajTrake() {
    el.trake.innerHTML = ''
    artikli.slice(0, 40).forEach(function (_, j) {
      var t = document.createElement('i')
      if (j === i) t.className = 'je-aktivna'
      else if (j < i) t.className = 'je-prosla'
      el.trake.appendChild(t)
    })
  }

  function idiNa(n) {
    if (!artikli.length) return
    i = Math.max(0, Math.min(n, artikli.length - 1))
    var a = artikli[i]
    el.slika.src = a.slika
    el.slika.alt = a.naziv
    el.ime.textContent = a.naziv
    el.ime.href = a.url
    el.detalji.href = a.url
    el.cena.textContent = a.cena
    el.brojac.textContent = (i + 1) + ' / ' + artikli.length
    if (el.korpa) el.korpa.value = a.varijanta
    if (el.odmah) el.odmah.value = a.varijanta
    // U rezimu pouzeca kupovina ide preko obrasca na strani artikla.
    if (el.poruci) el.poruci.href = a.url
    crtajTrake()
    zakaziSledeci()
  }

  function ucitaj(idx, pocetak, oznaka) {
    var li = stavke[idx]
    if (!li) return
    katIdx = idx
    var handle = li.getAttribute('data-kolekcija')
    el.naziv.textContent = li.getAttribute('data-naziv')
    el.broj.textContent = li.getAttribute('data-broj') + ' artikala · ' + (idx + 1) + ' od ' + stavke.length + ' kategorija'
    el.kat.href = '/collections/' + handle
    artikli = []; i = 0
    el.trake.innerHTML = ''
    el.slika.removeAttribute('src')

    fetch('/collections/' + handle + '/products.json?limit=50')
      .then(function (r) { return r.json() })
      .then(function (j) {
        artikli = (j.products || []).map(function (p) {
          var v = (p.variants || [])[0] || {}
          var s = (p.images || [])[0]
          return {
            handle: p.handle,
            naziv: p.title,
            url: '/products/' + p.handle,
            slika: s ? s.src : '',
            cena: v.price ? Number(v.price).toLocaleString('sr-Latn-RS') + ' RSD' : '',
            varijanta: v.id || ''
          }
        }).filter(function (a) { return a.slika && a.varijanta })
        if (!artikli.length) return
        var poc = pocetak || 0
        if (oznaka) {
          // Redosled sa servera ne mora da prati redosled krugova,
          // pa je oznaka artikla pouzdanija od rednog broja.
          var n = artikli.findIndex(function (a) { return a.handle === oznaka })
          if (n >= 0) poc = n
        }
        idiNa(poc)
      })
      .catch(function () { /* ako ne stigne, pregled ostaje prazan */ })
  }

  function otvori(idx) {
    prica.hidden = false
    document.body.style.overflow = 'hidden'
    // U rezimu artikala krug nosi redni broj, pa pregled krece bas od njega.
    var pocetak = parseInt(stavke[idx].getAttribute('data-pocetak'), 10) || 0
    ucitaj(idx, pocetak, stavke[idx].getAttribute('data-artikal'))
  }
  function zatvori() {
    stani()
    prica.hidden = true
    document.body.style.overflow = ''
  }

  stavke.forEach(function (li, idx) {
    li.querySelector('.krugovi__slika-link').addEventListener('click', function () { otvori(idx) })
  })

  prica.querySelector('.prica__zatvori').addEventListener('click', zatvori)
  prica.addEventListener('click', function (e) { if (e.target === prica) zatvori() })
  prica.querySelector('.prica__strelica--levo').addEventListener('click', function () { idiNa(i - 1) })
  prica.querySelector('.prica__strelica--desno').addEventListener('click', function () { idiNa(i + 1) })
  var gore = prica.querySelector('.prica__strelica--gore')
  var dole = prica.querySelector('.prica__strelica--dole')
  if (rezim === 'proizvodi') {
    gore.hidden = true
    dole.hidden = true
  } else {
    gore.addEventListener('click', function () { if (katIdx > 0) ucitaj(katIdx - 1, 0) })
    dole.addEventListener('click', function () { if (katIdx < stavke.length - 1) ucitaj(katIdx + 1, 0) })
  }

  el.okvir.addEventListener('pointerdown', function () { pauza = true; stani() })
  el.okvir.addEventListener('pointerup', function () { pauza = false; zakaziSledeci() })
  el.okvir.addEventListener('pointercancel', function () { pauza = false; zakaziSledeci() })

  document.addEventListener('keydown', function (e) {
    if (prica.hidden) return
    if (e.key === 'Escape') zatvori()
    else if (e.key === 'ArrowRight') idiNa(i + 1)
    else if (e.key === 'ArrowLeft') idiNa(i - 1)
    else if (e.key === 'ArrowDown' && rezim !== 'proizvodi') { e.preventDefault(); if (katIdx < stavke.length - 1) ucitaj(katIdx + 1, 0) }
    else if (e.key === 'ArrowUp' && rezim !== 'proizvodi') { e.preventDefault(); if (katIdx > 0) ucitaj(katIdx - 1, 0) }
  })

  /* prevlacenje prstom */
  var dodir = null
  el.okvir.addEventListener('touchstart', function (e) {
    dodir = { x: e.touches[0].clientX, y: e.touches[0].clientY }
  }, { passive: true })
  el.okvir.addEventListener('touchend', function (e) {
    if (!dodir) return
    var dx = e.changedTouches[0].clientX - dodir.x
    var dy = e.changedTouches[0].clientY - dodir.y
    if (Math.abs(dx) > Math.abs(dy) * 1.4 && Math.abs(dx) > 44) idiNa(dx < 0 ? i + 1 : i - 1)
    else if (rezim !== 'proizvodi' && Math.abs(dy) > Math.abs(dx) * 1.4 && Math.abs(dy) > 70) {
      if (dy < 0 && katIdx < stavke.length - 1) ucitaj(katIdx + 1, 0)
      else if (dy > 0 && katIdx > 0) ucitaj(katIdx - 1, 0)
    }
    dodir = null
  }, { passive: true })
})()
